var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWhite8Inline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 78,
  height: 83,
  viewBox: "0 0 78 83",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M69.8 19.8 53.4 35.4c-.6.6-.9 1.1-.9 2.3v43.6c0 .5.4.9.9.9h16.9c.5 0 .9-.4.9-.9V20.2c.1-.6-.3-1.5-1.4-.4M22.7 40 6.3 55.6c-.6.6-.9 1.1-.9 2.3v23.3c0 .5.4.9.9.9h16.9c.5 0 .9-.4.9-.9V40.4c.1-.5-.3-1.4-1.4-.4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.3.9c0-.1 0-.3-.1-.4-.1-.1-.2-.1-.3-.1h-.2L64.2 3.2H64c-.1 0-.2.1-.2.1-.2.2-.2.5 0 .7l.1.1L66.8 7 38.4 35.4 25.3 22.3c-.1-.1-.4-.1-.5 0l-3.6 3.6-21 21c-.1.1-.1.4 0 .5L3.8 51c.1.1.4.1.5 0l20.8-20.7 9.5 9.5 3.6 3.6c.1.1.4.1.5 0l32.2-32.2 3 3c.2.2.5.2.7 0 .1-.1.1-.2.1-.3l2.8-12.8-.2-.2Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m46.4 42.8-7.9 8c-.2.1-.4.1-.5 0l-7.2-7.3c-1.3-1.3-1.6-.2-1.6.3v37.6c0 .5.4.9.9.9H47c.5 0 .9-.4.9-.9V43.2c0-.7-.4-1.6-1.5-.4"
}))));
export default SvgWhite8Inline;